// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared dashboard application statuses */
.submission-status {
  border: 1px solid #d0d5dd;
  background: #f2f4f7;
  color: #475467;
}

.submission-status.process-1,
.performance-status.process-1,
.e2e_table_status_submitted,
.e2e_benchsales_process_submitted,
.employee-drilldown .submission-status.process-1 {
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  color: #ea580c !important;
  font-weight: 800;
}

.submission-status.process-1::before,
.performance-status.process-1::before,
.e2e_table_status_submitted::before,
.e2e_benchsales_process_submitted::before {
  content: "";
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  margin-right: 5px;
  border-radius: 50%;
  background: #f97316;
}

.submission-status.process-2 {
  border-color: #fed7aa;
  background: #fff7ed;
  color: #c2410c;
}

.submission-status.process-3 {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}
.e2e_table_status_submitted::before { display: none; }
.e2e_table_status_submitted i { background: #f97316 !important; }
/* BenchSales keeps complete, consistently sized process badges. */
.e2e_benchsales_process_badge.e2e_benchsales_process_submitted{border:1px solid #bfdbfe!important;background:#eff6ff!important;box-shadow:none!important;color:#1d4ed8!important}
.e2e_benchsales_process_badge.e2e_benchsales_process_submitted::before{width:6px;height:6px;flex:0 0 6px;margin-right:1px;border-radius:50%;background:#3b82f6}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/submissionStatusOverrides.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;EAKE,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,UAAU;EACV,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA,sCAAsC,aAAa,EAAE;AACrD,gCAAgC,8BAA8B,EAAE;AAChE,kEAAkE;AAClE,+DAA+D,kCAAkC,CAAC,4BAA4B,CAAC,yBAAyB,CAAC,uBAAuB;AAChL,uEAAuE,SAAS,CAAC,UAAU,CAAC,YAAY,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,kBAAkB","sourcesContent":["/* Shared dashboard application statuses */\n.submission-status {\n  border: 1px solid #d0d5dd;\n  background: #f2f4f7;\n  color: #475467;\n}\n\n.submission-status.process-1,\n.performance-status.process-1,\n.e2e_table_status_submitted,\n.e2e_benchsales_process_submitted,\n.employee-drilldown .submission-status.process-1 {\n  border: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  color: #ea580c !important;\n  font-weight: 800;\n}\n\n.submission-status.process-1::before,\n.performance-status.process-1::before,\n.e2e_table_status_submitted::before,\n.e2e_benchsales_process_submitted::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  flex: 0 0 6px;\n  margin-right: 5px;\n  border-radius: 50%;\n  background: #f97316;\n}\n\n.submission-status.process-2 {\n  border-color: #fed7aa;\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.submission-status.process-3 {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #15803d;\n}\n.e2e_table_status_submitted::before { display: none; }\n.e2e_table_status_submitted i { background: #f97316 !important; }\n/* BenchSales keeps complete, consistently sized process badges. */\n.e2e_benchsales_process_badge.e2e_benchsales_process_submitted{border:1px solid #bfdbfe!important;background:#eff6ff!important;box-shadow:none!important;color:#1d4ed8!important}\n.e2e_benchsales_process_badge.e2e_benchsales_process_submitted::before{width:6px;height:6px;flex:0 0 6px;margin-right:1px;border-radius:50%;background:#3b82f6}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
